import React from "react";
import { Paper, Tabs, Tab, Box, Typography } from "@mui/material";
import StoScope from "./SearchTermOperaionTabsContent/STO_Scopes/STO_Scope";
import StoSearchTerms from "./SearchTermOperaionTabsContent/STO_SearchTerms/STO_SearchTerms";
import StoAirRecomondation from "./SearchTermOperaionTabsContent/STO_AiRecomondation/STO_AirRecomondation";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const SearchTermOperationTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      {/* Tabs header */}
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        sx={{
          "& .MuiTab-root": { textTransform: "none", fontWeight: 500 },
        }}
      >
        <Tab label="SCOPES" />
        <Tab label="SEARCH TERMS" />
        <Tab label="AI RECOMMENDATIONS" />
      </Tabs>

      {/* Tab panels */}
      <TabPanel value={value} index={0}>
        <StoScope />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <StoSearchTerms />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <StoAirRecomondation />{" "}
      </TabPanel>
    </Paper>
  );
};

export default SearchTermOperationTabs;
